import type { SelectedRuleIds } from '@/diagnostic/domain/SelectedRuleIds.ts';

type ApiInformationBuilder = {
  content: File;
};

class ApiInformationWithContent {
  readonly #content: File;

  private constructor(builder: ApiInformationBuilder) {
    this.#content = builder.content;
  }

  static of(builder: ApiInformationBuilder) {
    return new ApiInformationWithContent(builder);
  }

  withRules(ruleIds: SelectedRuleIds): ApiInformationToDiagnose {
    return new ApiInformationToDiagnose({ info: this, ruleIds });
  }

  get content(): File {
    return this.#content;
  }
}

type ApiInformationWithRulesBuilder = {
  info: ApiInformationWithContent;
  ruleIds: SelectedRuleIds;
};

class ApiInformationToDiagnose {
  readonly #info: ApiInformationWithContent;
  readonly #ruleIds: SelectedRuleIds;

  constructor(builder: ApiInformationWithRulesBuilder) {
    this.#info = builder.info;
    this.#ruleIds = builder.ruleIds;
  }

  withRules(ruleIds: SelectedRuleIds): ApiInformationToDiagnose {
    return new ApiInformationToDiagnose({ info: this.#info, ruleIds });
  }

  get content(): File {
    return this.#info.content;
  }

  get rules(): SelectedRuleIds {
    return this.#ruleIds;
  }
}

export type { ApiInformationToDiagnose };

export const createApiInformation = (content: File): ApiInformationWithContent =>
  ApiInformationWithContent.of({ content });

export type ApiInformation = ApiInformationWithContent | ApiInformationToDiagnose;

export const isApiInformationToDiagnose = (
  apiInformation: ApiInformation,
): apiInformation is ApiInformationToDiagnose => apiInformation instanceof ApiInformationToDiagnose;
